// EFKT-MOCK: shared by both mappers below — see IBranch's field comments in models.ts.
function mockBranchSettings() {
    return {
        countryCode: undefined,
        maxImageUploaded: undefined,
        useUpperCase: false,
        endUserInvoicing: true,
        businessInvoicing: true,
        locale: undefined,
        contactPersonId: undefined,
        axCustomerId: undefined,
    };
}
export function mapBranchFromDto(dto) {
    var _a, _b, _c;
    return {
        id: dto.id,
        name: dto.name,
        countryCode: dto.countryCode,
        maxImageUploaded: dto.maxImageUploaded,
        useUpperCase: (_a = dto.useUpperCase) !== null && _a !== void 0 ? _a : mockBranchSettings().useUpperCase,
        endUserInvoicing: (_b = dto.endUserInvoicing) !== null && _b !== void 0 ? _b : mockBranchSettings().endUserInvoicing,
        businessInvoicing: (_c = dto.businessInvoicing) !== null && _c !== void 0 ? _c : mockBranchSettings().businessInvoicing,
        locale: dto.locale,
        contactPersonId: dto.contactPersonId,
        axCustomerId: dto.axCustomerId,
    };
}
/**
 * `GET /Authentication/user/branches` row into `IBranch`. Unlike `mapBranchFromDto` above this one
 * needs no placeholders: the row carries real per-branch settings. `axCustomerId` and the address
 * fields still arrive null on Efkt — see `IUserBranchDto` — but that is the wire telling the truth,
 * not a mock, so they pass through as-is rather than being filled in.
 */
export function mapBranchFromUserBranchDto(dto) {
    var _a, _b, _c, _d;
    return {
        id: dto.id,
        name: dto.name,
        countryCode: dto.country,
        maxImageUploaded: (_a = dto.settings) === null || _a === void 0 ? void 0 : _a.maxImageUpload,
        useUpperCase: !!((_b = dto.settings) === null || _b === void 0 ? void 0 : _b.enforceUpperCaseReference),
        endUserInvoicing: !!((_c = dto.settings) === null || _c === void 0 ? void 0 : _c.endUserInvoicing),
        businessInvoicing: !!((_d = dto.settings) === null || _d === void 0 ? void 0 : _d.businessInvoicing),
        contactPersonId: dto.contactPersonId,
        axCustomerId: dto.axCustomerId,
    };
}
/** Passthrough — see `models.ts::IAccountSettings` for why this is its own model rather than the DTO. */
export function mapAccountSettingsFromDto(dto) {
    return { ...dto };
}
